import { render, staticRenderFns } from "./PaymentMethodPage.vue?vue&type=template&id=15dca562&"
import script from "./PaymentMethodPage.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports